var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#009D52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6297 19.0478H45.7154C45.9257 19.0478 46.0963 19.2184 46.0963 19.4287V46.8573C46.0963 47.0676 45.9257 47.2383 45.7154 47.2383H39.6297C39.4194 47.2383 39.2487 47.0676 39.2487 46.8573V19.4287C39.2487 19.2184 39.4193 19.0478 39.6297 19.0478Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.52381
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3869 27.4287H34.4725C35.1037 27.4287 35.6154 27.9404 35.6154 28.5716V46.8573C35.6154 47.4884 35.1037 48.0001 34.4725 48.0001H28.3869C27.7557 48.0001 27.244 47.4884 27.244 46.8573V28.5716C27.244 27.9404 27.7557 27.4287 28.3869 27.4287Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2285 34.2859H17.1429C16.5117 34.2859 16 34.7976 16 35.4287V46.8573C16 47.4884 16.5117 48.0002 17.1429 48.0002H23.2285C23.8597 48.0002 24.3714 47.4884 24.3714 46.8573V35.4287C24.3714 34.7976 23.8597 34.2859 23.2285 34.2859Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBars);
export default __webpack_public_path__ + "static/media/green-bars.8f18e9269c1f2860b47960ee64e2a64e.svg";
export { ForwardRef as ReactComponent };